export const blockIconsCommunicationChatBubbleNew = (
	<span className='material-symbols-outlined'>chat_bubble</span>
);
